export function readGroupId(search: string): number | null {
  const value = new URLSearchParams(search).get('conversationId');
  if (!value || !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
}

export function writeGroupId(id: number | null): void {
  const url = new URL(window.location.href);
  if (id === null) url.searchParams.delete('conversationId');
  else url.searchParams.set('conversationId', String(id));
  window.history.replaceState(window.history.state, '', url);
}
